export default __webpack_public_path__ + "static/media/849.dd2788c8.png";